var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big-button",class:{current:_vm.isCurrent},attrs:{"data-index":_vm.index}},[_c('a',{staticClass:"link pr-5 pl-3 py-2 mb-2",class:{disabled:_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }